import themesData from './monaco-themes.json';

/**
 * Get all available theme names
 */
export function getAvailableThemes() {
  return Object.keys(themesData);
}

/**
 * Get theme configuration by name
 */
export function getThemeConfig(themeName) {
  return themesData[themeName] || themesData['cursor-dark'];
}

/**
 * Check if a theme exists
 */
export function isValidTheme(themeName) {
  return themeName in themesData;
}

/**
 * Get the default theme name
 */
export function getDefaultTheme() {
  return 'revolt';
}

/**
 * Theme metadata for UI display
 */
export const themeMetadata = {
  'revolt': {
    name: 'Revolt',
    description: 'Revolt\'s signature red theme'
  },
  'cursor-dark': {
    name: 'Cursor Dark',
    description: 'Classic Cursor dark theme with purple/blue accents'
  },
  'cursor-dark-modern': {
    name: 'Cursor Dark Modern',
    description: 'Modern take on Cursor dark with cleaner colors'
  },
  'cursor-dark-ocean': {
    name: 'Cursor Dark Ocean',
    description: 'Ocean-inspired dark theme with teal/purple accents'
  },
  'cursor-dark-monokai': {
    name: 'Cursor Dark Monokai',
    description: 'Monokai-inspired dark theme with vibrant colors'
  }
};